import { __rest, __assign } from 'tslib';
import React from 'react';
import { NvButton } from '@invitae/ids-react';

var AddToCart = function (_a) {
    var productId = _a.productId, Element = _a.element, rest = __rest(_a, ["productId", "element"]);
    var products = typeof productId === 'string' ? productId : productId.join(',');
    var generalAttributes = {
        'data-analytics-action': 'add-to-cart',
        'data-analytics-product-id': products,
    };
    var props = __assign(__assign({}, rest), generalAttributes);
    return Element ? React.createElement(Element, __assign({}, props)) : React.createElement(NvButton, __assign({}, props));
};

export { AddToCart as default };
//# sourceMappingURL=AddToCart.esm.js.map
